import moment from "moment";
import "moment/locale/hu";
//import "moment/locale/de";
//import "moment/locale/fr";
//import "moment/locale/es";
//import "moment/locale/it";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import hu from 'date-fns/locale/hu';
registerLocale('hu', hu);
setDefaultLocale('hu');

moment.locale("hu");

let locale = {
	calendarSettings: {
		firstDayOfWeek: 1,
	    dayNames: ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"],
	    dayNamesShort: ["v", "h", "k", "sze", "cs", "p", "szo"],
	    dayNamesMin: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
	    monthNames: ["január", "február", "március", "április", "május", "június", "július", "augusztus", "szeptember", "október", "november", "december"],
	    monthNamesShort: ["jan", "feb", "már", "ápr", "máj", "jún", "júl", "aug", "szept", "okt", "nov", "dec"]
	},
	dateFormat: "yyyy.MM.dd."
};

export default locale;